export enum Type {
  STRING = 'string',
  INTEGER = 'integer',
  BOOLEAN = 'boolean',
  MULTIPLE_CHOICES = 'multiple_choices',
  SHEET = 'sheet'
}
